import {Injectable} from '@angular/core';
import {environment} from '~/environments/environment';
import {KeycloakService} from 'keycloak-angular';
import {AuthInit, CookieManagementService, JwtService, OauthService} from 'mclane-webauth-lib';
import {KeycloakHelperService} from '~/app/core/helpers/keycloak-helper.service';
import {LoggingService} from "mclane-apptemplate-lib";

@Injectable({
    providedIn: 'root'
})
export class AuthInitService {

    constructor(public console: LoggingService) {
    }

    public authSetup(keycloakService: KeycloakService, authInit: AuthInit,
                     jwtservice: JwtService, keyCloakHelperService: KeycloakHelperService,
                     cookieHelperService: CookieManagementService, oauthService: OauthService) {
        return new Promise((resolve, reject) => {
            keycloakService.init({
                loadUserProfileAtStartUp: true,
                config: environment.keycloak,
                initOptions: {onLoad: 'check-sso', checkLoginIframe: false}
            }).then(async () => {
                try {
                    await keycloakService.isLoggedIn().then(async (re) => {
                        if (re) {
                            await keycloakService.getToken().then((result) => {
                                jwtservice.setJwt(result);
                                oauthService.setIdpHintCookie();
                                // router.navigateByUrl('dashboard');
                            });
                        } else {
                            //  await router.navigateByUrl('home');
                            this.console.log('Logged Out');
                        }
                    });
                } catch (e) {

                } finally {
                    resolve(true);
                }
            });
        });
    }
}
